import { render, staticRenderFns } from "./CompanyPlate.vue?vue&type=template&id=5f62e2c6&"
import script from "./CompanyPlate.vue?vue&type=script&lang=js&"
export * from "./CompanyPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports